import { Component, OnInit,ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { User } from '../../../models/user';
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import  * as moment from 'moment-timezone';
import  * as moment1 from 'moment';

@Component({
    selector: 'app-reported',
    templateUrl: './reportedcontent.component.html',
  providers: [ SharedService,PopupSegmentComponent]

})
export class ReportedContentComponent implements OnInit {
   noZizFlag :boolean = false;
 token:string;
  zizcard= [];
  loader:boolean=false;
  pagedzizcard = [];
  page:number=1;
  pagesize:number=5;
  totalPages:number;
  expirein = [];
  key : string;
  public selected: string = '';
  public bflag: boolean;
  currentdate: number;
  objLoaderStatus: boolean = false;
userId : number;
name = "";
showcancel : boolean = false;
reportedBy  =[];
publishedBy =[];
showExpire = false;
  constructor(private localstorage : LocalStorage,private shareService :SharedService,
  private loaderService : LoaderService,private router : Router, 
  private dialogService:DialogService,private ref: ChangeDetectorRef,
  private PopupSegment: PopupSegmentComponent, 
  ) { 
    this.bflag = true;

  }

       
  // doRerender() {
  //   this.showReport();
  // }
  ngOnInit() {
    var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
     this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });

      this.currentdate =  Date.now();
this.reportedBy  =[];
this.localstorage.setStorage("country",'');
       this.token=this.localstorage.getStorage('token');

       var i=0;
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/reportedCampaign?currentPage="+this.page+"&currentSize="+this.pagesize, null, this.token).subscribe((result) => {
  console.log(result);

  if(result.data){
     this.loader=false;
//this.zizcard = result.data;
this.totalPages = result.pagination.totalPages;
  if(result.data.length>0) {
          this.pagedzizcard = result.data;
         for(var i=0; i<result.data.length; i++){
        this.reportedBy[i] = result.data[i].reportedByUser;
this.publishedBy[i] = result.data[i].advBaseModel.name;
   var getResult = this.calculateDiff(result.data[i].campaignModel.endAt,result.data[i].campaignModel.startAt);
   if(result.data[i].campaignModel.endAt){
            var expire =  this.convertDaysHour2(result.data[i].campaignModel.campaignDuration[0].endTime, result.data[i].campaignModel.endAt); 
             let day = expire.day;
             let hour = expire.hour;
             let minute = expire.minute;
             let seconds = expire.seconds;
             this.expirein[i] =[day,hour,minute,seconds];
           }
           console.log("expire in");
           console.log(this.expirein[i]);
          this.pagedzizcard[i].campaignModel.expiretime=this.expirein[i];
//  var expire = this.convertDaysHour(result.data[i].campaignModel.startAt,getResult);
//                       result.data[i].expiretime =expire;
console.log(getResult);
          //  if(this.pagedzizcard[i].campaignModel.name == '' || this.pagedzizcard[i].campaignModel.name == null){
          //  this.pagedzizcard[i].campaignModel.name = "Test";
          //  }
            if(getResult >=0){
            this.pagedzizcard[i].campaignModel.showExpire = false;
          // this.pagedzizcard[i].campaignModel.expiretime=result.data[i].expiretime;
            }
            else{
   this.pagedzizcard[i].campaignModel.showExpire = true;
            }
           this.pagedzizcard[i].campaignModel.reportedBy=this.reportedBy[i];
            this.pagedzizcard[i].campaignModel.publishedBy=this.publishedBy[i];
        
          this.zizcard.push(this.pagedzizcard[i].campaignModel);
  console.log(this.zizcard);  
    }
 this.noZizFlag = false;
       
            }
else{
   this.noZizFlag = true;
}
   this.loaderService.displayLoader(false);
  
}
else{
  this.noZizFlag = true;
     this.loaderService.displayLoader(false);

}

     });
  }
  
  

 formatDate(date) {

        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }


     calculateDiff(str1, str2) {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date(str1);
        var d = new Date();
        console.log(d);
        console.log(firstDate)
        var secondDate = new Date(str2);
                console.log(secondDate)
if(secondDate >d){
        var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
}
else{
  if(firstDate>d){
          var diffDays = Math.round(Math.abs((firstDate.getTime() - d.getTime()) / (oneDay)));
  }
  else{
    var diffDays = -1;
  }
}
console.log(diffDays);
        return diffDays;
    }
    getExpiryTimeString(d, h, m, s) {
        return  d + "D " + h + "H " + m + "M " + s + "S";
    }

     convertDaysHour(startAt, days = null) {
        let startdate = this.formatDate(startAt);
        let current = this.formatDate(this.currentdate);
                      var currentdate = new Date();

        console.log(startdate);
                console.log(current);
        if (startdate == current && days == 1) {
            var currentdate = new Date();
            return this.getExpiryTimeString(0, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
        } else {
            days = (days == null ? 0 : days);
            if(startdate == current){
            return this.getExpiryTimeString(days-1, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
          }
          else{
            if(startdate>current){
             return this.getExpiryTimeString(days,0,0,0);
            }
            else{
              console.log("inside else start date less than current")
       return this.getExpiryTimeString(days, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
       
            }
          }
            // this.campaign.expiretime=this.getExpiryTimeString(this.someRange,0,0,0);
        }
       
    
      }

//scroll pagination
onScroll() {
    window.onscroll = () => {
         let status = "not reached";
         let windowHeight = "innerHeight" in window ? window.innerHeight
             : document.documentElement.offsetHeight;
         let body = document.body, html = document.documentElement;
         let docHeight = Math.max(body.scrollHeight,
             body.offsetHeight, html.clientHeight,
             html.scrollHeight, html.offsetHeight);
         let windowBottom = windowHeight + window.pageYOffset;
         if (windowBottom >= docHeight) {
           status = 'bottom reached';
           this.page++;
           console.log(status);
           console.log(this.page);
           if(this.page <= this.totalPages){
              this.getZizCard(this.page);
           }
           
         }
         
      };
  }
//Pagination scroll end
getZizCard(page) {
 var token = this.localstorage.getStorage("token");
  this.loader=true;
this.reportedBy  =[];

  this.shareService.CallDatawithToken("admin/reportedCampaign?currentPage="+page+"&currentSize="+this.pagesize,null,token).subscribe((result) => {
  
        this.loader=false;
        if(result.data.length>0) {
          this.pagedzizcard = result.data;
                    console.log(this.pagedzizcard);

         for(var i=0; i<result.data.length; i++){
                   this.reportedBy[i] = result.data[i].reportedByUser;
this.publishedBy[i] = result.data[i].advBaseModel.name;
var getResult = this.calculateDiff(result.data[i].campaignModel.endAt,result.data[i].campaignModel.startAt);
if(result.data[i].campaignModel.endAt){
            var expire =  this.convertDaysHour2(result.data[i].campaignModel.campaignDuration[0].endTime, result.data[i].campaignModel.endAt); 
             let day = expire.day;
             let hour = expire.hour;
             let minute = expire.minute;
             let seconds = expire.seconds;
             this.expirein[i] =[day,hour,minute,seconds];
           }
             console.log("expire in");
           console.log(this.expirein[i]);
          this.pagedzizcard[i].campaignModel.expiretime=this.expirein[i];
//  var expire = this.convertDaysHour(result.data[i].campaignModel.startAt,getResult);
//                       result.data[i].expiretime =expire;
          //  if(this.pagedzizcard[i].campaignModel.name == '' || this.pagedzizcard[i].campaignModel.name == null){
          //  this.pagedzizcard[i].campaignModel.name = "Test";
          //  }
          if(getResult >=0){
            this.pagedzizcard[i].campaignModel.showExpire = false;
            }
            else{
   this.pagedzizcard[i].campaignModel.showExpire = true;
            }
           this.pagedzizcard[i].campaignModel.reportedBy=this.reportedBy[i];
            this.pagedzizcard[i].campaignModel.publishedBy=this.publishedBy[i];
        
          this.zizcard.push(this.pagedzizcard[i].campaignModel);
  console.log(this.zizcard);  
    }
       
            }
      // else {
      //   this.zizcard=[];
      // }
  
     });
}

convertDaysHour2(campaignDuration: number, value: number) {
          console.log("campaignDuration"+campaignDuration)
          var dateFormat;
          var dateTime;
          var getDate = new Date(value);
          var now;
          dateFormat = getDate.toString()
          dateFormat = moment1.utc(getDate).format('YYYY-MM-DD');
          dateTime = moment1(dateFormat + ' ' + campaignDuration, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
          now = new Date();
          now = moment1(now).format('YYYY-MM-DD HH:mm');
          console.log("dateTime"+dateTime)
          console.log("now"+now)
          let getExpiryDate= moment(dateTime,"YYYY-MM-DD HH:mm:ss").diff(moment(now,"YYYY-MM-DD HH:mm:ss"));
          let seconds = Math.floor(getExpiryDate / 1000);
            let minute = Math.floor(seconds / 60);
            seconds = seconds % 60;
            let  hour = Math.floor(minute / 60);
            minute = minute % 60;
            let day = Math.floor(hour / 24);
            hour = hour % 24;
            return {
            day: day,
            hour: hour,
            minute: minute,
            seconds: seconds
    };
      }

 findDeals(latitude:string, longitutude: string) {
    window.open("https://www.google.com/maps?q="+latitude+","+longitutude, "_blank");
 }

 deleteContent(id){
        //this.id = id;
       this.showConfirmDelete(id);
 }

    showConfirmDelete(id){
              var token=this.localstorage.getStorage('token');

this.showcancel = true;
let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Reported Campaign Information', 
                message:'Are you sure you want to delete the campaign?',
              data: [],
            showcancel : this.showcancel})
                .subscribe((isConfirmed)=>{
 if(isConfirmed){
              this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/deleteCampaign/"+id,{},token).subscribe((result) => {
    console.log(result.data);
    if(result.data.status == true){
      this.showDelete();   
    }

    this.loaderService.displayLoader(false);

});
 }
                });

        }

        showDelete() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Reported Campaign Information', 
                message:'Campaign Deleted Successfully',
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                  if(isConfirmed){
                    window.location.reload();
                  }
                });
        }
}



// WEBPACK FOOTER //
// ./src/app/admin/layout/reportedContent/reportedcontent.component.ts